import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';
import Loader from '../common/Loader';

const LoginCallback = () => {
  const { oktaAuth } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Parse and process the callback from Okta
        await oktaAuth.handleRedirect();
        navigate('/');
      } catch (err) {
        setError(`Login failed: ${err.message}`);
        console.error('Login error:', err);
      }
    };

    handleCallback();
  }, [oktaAuth, navigate]);

  if (error) {
    return <div className="error-container">{error}</div>;
  }

  return <Loader />;
};

export default LoginCallback;